import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import _ from 'underscore';
import  { spanish } from "../../constants/spanish";
import { English } from "../../constants/english";
import { config } from "../../constants/domainConfig";
import { Container, Row, Col } from 'reactstrap';
import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { clearHistory } from '../../actions/HistoryActions';
import { searchText } from '../../actions/SearchActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { console_log, fromNow,bidiotvMoviesListByLang } from '../../utils/helper';
import { esmobiotv } from "../../constants/esmobiotv";
import { movies } from '../../constants/movies';
import {addChannelHistory, addVideoHistory,addShowHistory,bucketAccess} from "../../actions/HistoryActions";
import { FormattedMessage } from 'react-intl';

class History extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.clearHistory = this.clearHistory.bind(this);
    }
    componentWillMount(){
        axios.get(vars.BASE_API_URL+'/history')
            .then((history)=>{
                if (history.data.data) {
                    this.props.addChannelHistory(history.data.data.channels);
                    this.props.addVideoHistory(history.data.data.videos);
                    this.props.addShowHistory(history.data.data.shows);
                }
            })
    }
    componentDidMount() {
        this.props.show();
        setTimeout(() => {
            this.props.hide();
        }, 1500);
        window.scrollTo(0, 0);
        let history;
        if(config.lang == 'es'){
            history = "Historia"
        }
        else if (config.lang == 'be') history = 'Geschiedenis';
        else if (config.lang == 'it') history = 'Cronologia';
        else if (config.lang == 'id') history = 'Riwayat';
        else if (config.lang == "se") history = "Historik";
        else if (config.lang == "ar") history = "سجل";
        else if (config.lang == "no") history = "Historie";
        else if (config.lang == "fr") history = "Histoire";
        else if (config.lang == "ee") history = "Ajalugu";
        else if (config.lang == "tr") history = "Geçmiş";
        else if (config.lang == "lv") history = "Vēsture";
        else if (config.lang == "lt") history = "Istorija";
        else if (config.lang == "sr") history = "Историја";
        else if (config.lang == "th") history = "ประวัติ";
        else if (config.lang == "el") history = "Ιστορικό";
        else if (config.lang == "de") history = "Verlauf";
        else if (config.lang == "cs") history = "Historie";
        else if(config.lang === 'pt') history = "Histórico" 

             else {
               history = "History";
             }
        this.props.setHeaderTitle(history);
    }

    goToPlay(data, event) {
        event.preventDefault();
        if (data.channel) {
            this.props.history.push(`/play/channel?uid=${this.props.access.uid}`);
        } else if(data.video){
            this.props.history.push(`/play/video/?vid=${data.video.id}&uid=${this.props.access.uid}`);
        }
        else{
            this.props.history.push(`/show?uid=${this.props.access.uid}`);
        }
        this.props.getVideoOrChannelRelatedData(data);
    }

    clearHistory() {
        axios.delete(vars.BASE_API_URL+"/history")
            .then((response) => {
                console_log(response);
            })
            .catch((error) => {
                console_log(error);
            });
        this.props.clearHistory();
    }
    calculateHistory(historyTime){
        let historyTiming = []
        let minutesText='Minutes',hoursText='Hours',daysText='Days';
         if (config.lang == "ar"){ 
            minutesText = "منذ دقيقة";
            hoursText = "منذ ساعات";
            daysText = "بضعة ايام سابقه";
            }

        historyTime.map((e)=>{
            let playedDate = new Date(e.createdAt);
            let currentDate = new Date();
            let timeDiff = Math.abs(currentDate.getTime() - playedDate.getTime());
            if(timeDiff >= 60000 && timeDiff < 3600000){
                let timeinminutes = Math.round(timeDiff/(60 * 1000));
                historyTiming.push({time:timeinminutes + " "+minutesText,name:e.name})
            }
            else if(timeDiff >= 3600000 && timeDiff < 86400000){
                let timeinhours = Math.round(timeDiff / (3600 * 1000));
                historyTiming.push({time:timeinhours + " "+hoursText,name:e.name})

            }
            else if(timeDiff >= 86400000){
                let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
                historyTiming.push({time:diffDays + " "+daysText,name:e.name})

            }
            else{
                historyTiming.push({time:1 + " "+minutesText,name:e.name})

            }

        })
        return historyTiming;
    }

    render() {
        let historyVideos;
        let historyShows;
        let mixContent = bidiotvMoviesListByLang.concat(this.props.category.videos);
        let historyVideoIds = this.props.historyVideos.videos.map(v => v.videoId);
        let historyShowsIds =  this.props.historyVideos.shows.map(v => v.showId);
        let bidiotvHistory = [].concat.apply([], bidiotvMoviesListByLang.map((c) => c.videos)).filter((v) => {
            if (~historyVideoIds.indexOf(v.id)) {
                return v;
            }
        });
        let watchvideoHistory =[].concat.apply([], mixContent.map((c) => c.videos)).filter((v) => {
            if (~historyVideoIds.indexOf(v.id)) {
                return v;
            }
        });
        let esdomainHistory = [].concat.apply([], esmobiotv.map((c) => c.videos)).filter((v) => {
            if (~historyShowsIds.indexOf(v.id)) {
                return v;
            }
        });
        let orangeHistoryvideos = [].concat.apply([], this.props.category.videos.map((c) => c.videos)).filter((v) => {
            if (~historyVideoIds.indexOf(v.id)) {
                return v;
            }
        });
        let orangeHistoryshows = [].concat.apply([], movies.map((c) => c.videos)).filter((v) => {
            if (~historyShowsIds.indexOf(v.id)) {
                return v;
            }
        });
        //for history time calculation
        let historytimeShowsIds;
        let historytimeVideoIds;
        let historyTime;
        let historyvideoTime;

        if(config.title == 'es'){
            historyShows = esdomainHistory
            historytimeShowsIds = esdomainHistory.map(v => v.id);
            historyTime =  [].concat.apply([],this.props.historyVideos.shows.map((c) => c)).filter((v) => {
                if (~historytimeShowsIds.indexOf(v.showId)) {
                    return v;
                }
            });
            let history =  this.calculateHistory(historyTime);
            history.map((t,index)=>{
                let show =_.find(historyShows, function(num){ if(t.name == num.name)return num });
                if(show){
                    show["time"] =t.time;
                }
            })

        }
        else if(config.title == 'bidiotv'){
            historyVideos = bidiotvHistory;
            historytimeVideoIds = bidiotvHistory.map(v => v.id);
            historyvideoTime =  [].concat.apply([],this.props.historyVideos.videos.map((c) => c)).filter((v) => {
                if (~historytimeVideoIds.indexOf(v.videoId)) {
                    return v;
                }
            });

            let historyVideo =  this.calculateHistory(historyvideoTime);
            historyVideo.map((t,index)=>{
                let video =_.find(historyVideos, function(num){ if(t.name == num.name)return num });
                if(video){
                    video["time"] =t.time;
                }

            })
        }
        else if(config.title == 'watch'){
            historyVideos = watchvideoHistory;
            historyShows = orangeHistoryshows;
            historytimeShowsIds = orangeHistoryshows.map(v => v.id);
            historyTime =  [].concat.apply([],this.props.historyVideos.shows.map((c) => c)).filter((v) => {
                if (~historytimeShowsIds.indexOf(v.showId)) {
                    return v;
                }
            });

            let history =  this.calculateHistory(historyTime);
            history.map((t,index)=>{
                let show =_.find(historyShows, function(num){ if(t.name == num.name)return num });
                if(show){
                    show["time"] =t.time;
                }

            })
            historytimeVideoIds = watchvideoHistory.map(v => v.id);
            historyvideoTime =  [].concat.apply([],this.props.historyVideos.videos.map((c) => c)).filter((v) => {
                if (~historytimeVideoIds.indexOf(v.videoId)) {
                    return v;
                }
            });

            let historyVideo =  this.calculateHistory(historyvideoTime);
            historyVideo.map((t,index)=>{
                let video =_.find(historyVideos, function(num){ if(t.name == num.name)return num });
                if(video){
                    video["time"] =t.time;
                }

            })
        }
        else{
            historyVideos = orangeHistoryvideos;
            historyShows = orangeHistoryshows;
            historytimeShowsIds = orangeHistoryshows.map(v => v.id);
            historyTime =  [].concat.apply([],this.props.historyVideos.shows.map((c) => c)).filter((v) => {
                if (~historytimeShowsIds.indexOf(v.showId)) {
                    return v;
                }
            });
            let history =  this.calculateHistory(historyTime);
            history.map((t,index)=>{
                let show =_.find(historyShows, function(num){ if(t.name == num.name)return num });
                if(show){
                    show["time"] =t.time;
                }

            })

            historytimeVideoIds = orangeHistoryvideos.map(v => v.id);
            historyvideoTime =  [].concat.apply([],this.props.historyVideos.videos.map((c) => c)).filter((v) => {
                if (~historytimeVideoIds.indexOf(v.videoId)) {
                    return v;
                }
            });
            let historyVideo =  this.calculateHistory(historyvideoTime);
            historyVideo.map((t,index)=>{
                let video =_.find(historyVideos, function(num){ if(t.name == num.name)return num });
                if(video){
                    video["time"] =t.time;
                }

            })
        }

        const playIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#fff" d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>';
        const historyIconESMobile = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#4e0735" d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>';
        const deleteHistoryIcon = '<svg width="20" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 59"><path fill="#fff" d="M29.5 51c.552 0 1-.447 1-1V17c0-.553-.448-1-1-1s-1 .447-1 1v33c0 .553.448 1 1 1zM19.5 51c.552 0 1-.447 1-1V17c0-.553-.448-1-1-1s-1 .447-1 1v33c0 .553.448 1 1 1zM39.5 51c.552 0 1-.447 1-1V17c0-.553-.448-1-1-1s-1 .447-1 1v33c0 .553.448 1 1 1z"/><path fill="#fff" d="M52.5 6H38.456c-.11-1.25-.495-3.358-1.813-4.711C35.809.434 34.751 0 33.499 0H23.5c-1.252 0-2.31.434-3.144 1.289C19.038 2.642 18.653 4.75 18.543 6H6.5c-.552 0-1 .447-1 1s.448 1 1 1h2.041l1.915 46.021C10.493 55.743 11.565 59 15.364 59h28.272c3.799 0 4.871-3.257 4.907-4.958L50.459 8H52.5c.552 0 1-.447 1-1s-.448-1-1-1zM21.792 2.681C22.24 2.223 22.799 2 23.5 2h9.999c.701 0 1.26.223 1.708.681.805.823 1.128 2.271 1.24 3.319H20.553c.112-1.048.435-2.496 1.239-3.319zm24.752 51.298C46.538 54.288 46.4 57 43.636 57H15.364c-2.734 0-2.898-2.717-2.909-3.042L10.542 8h37.915l-1.913 45.979z"/></svg>';

        return (
            <section className="history py-0">
                {(config.title === "es" || config.title === "bidiotv") && window.innerWidth <= 575 ?
                    <button onClick={this.clearHistory} className="edit-button edit-button--history-icon" style={config.lang==='ar' ? {left:'20px',right:'unset'}:{}}>
                        <span dangerouslySetInnerHTML={{ __html: deleteHistoryIcon }}/>
                    </button>
                    :
                    <button className="edit-button" onClick={this.clearHistory} style={config.lang==='ar' ? {left:'20px',right:'unset'}:{}}>
                        <FormattedMessage id="clear"
                            defaultMessage="Clear"
                        />
                    </button>
                }
                <Row>
                    <Col xs="12">
                        {(this.props.historyVideos.channels && this.props.historyVideos.channels.length > 0) || (historyVideos && historyVideos.length > 0) ?
                            <div>
                                {(this.props.historyVideos.channels && this.props.historyVideos.channels.length > 0) ?
                                    <ul className="list-unstyled video-list video-list--history">
                                        {this.props.historyVideos.channels?
                                            this.props.historyVideos.channels.map((channel) => {
                                                return (
                                                    <li key={channel.channelId} className="video-list__item video-list__item--history" onClick={this.goToPlay.bind(this, {channel: channel})}>
                                                        <div className="video-list__image video-list__image--history">
                                                            <div className="channels-image">
                                                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                                    <img className="channels-thumb__image no-radius" src={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"} alt={channel.channelName} />
                                                                    <img className="channels-thumb__icon channel-thumb__icon--list" src={channel.channelLogo} alt={channel.channelName} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="video-list__details video-list__details--history">
                                                            <div className="video-list__upper">
                                                                <div className="video-list__upper__left">
                                                                    <h4 className="channels-thumb__name channels-thumb__name--list my-0">{channel.channelName}</h4>
                                                                    <span className="history-text">{(channel.createdAt)? fromNow(channel.createdAt) :""}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            : ""
                                        }
                                    </ul>
                                    : ""
                                }
                                {(this.props.historyVideos.videos && this.props.historyVideos.videos.length > 0) ?
                                    <ul className="list-unstyled video-list video-list--history">
                                        {historyVideos?
                                            historyVideos.map((video) => {
                                                return (
                                                    <li key={video.videoId} className="video-list__item video-list__item--history" onClick={this.goToPlay.bind(this, {video: {
                                                        id: video.id,
                                                        name: video.name,
                                                        preview: video.preview,
                                                        duration: video.duration
                                                    }})}>
                                                        <div className="video-list__image video-list__image--history">
                                                            <div className="channels-image">
                                                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                                    <img className="channels-thumb__image no-radius"  src={video.preview} alt={video.name} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="video-list__details video-list__details--history">
                                                            <div className="video-list__upper">
                                                                <div className="video-list__upper__left">
                                                                    <h4 className="channels-thumb__name channels-thumb__name--list my-0">{video.name}</h4>
                                                                    <span className="history-text">{`${video.time} ${config.lang==='ar' ? '':'Ago'}`}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            : ""
                                        }
                                    </ul>
                                    : ""
                                }
                                {(this.props.historyVideos.shows && this.props.historyVideos.shows.length > 0) ?
                                    <ul className="list-unstyled shows__wrap shows__wrap--history">
                                        {historyShows ?
                                            historyShows.map((m) => {
                                                return (
                                                    <li key={m.showId} className="shows"
                                                        onClick={this.goToPlay.bind(this, {
                                                            show: {
                                                                id: m.id,
                                                                name: m.name,
                                                                preview: m.preview,
                                                                duration: m.duration,
                                                                subCategory: m.subCategory
                                                            }
                                                        })}>
                                                        <div className="shows__details-history">
                                                            <img className="shows__thumb" src={m.preview} alt={m.name} />
                                                            <div className="video-list__details video-list__details--history">
                                                                <h4 className="channels-thumb__name channels-thumb__name--list my-0">{m.name}</h4>
                                                                <span className="history-text">{`${m.time} ${config.lang==='ar' ? '':'Ago'}`}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            : ""
                                        }
                                    </ul>
                                    : ""
                                }</div>:
                            <div className="no-data-text-center">
                                <p className="no-data-history-icon">
                                    <span dangerouslySetInnerHTML={{__html: historyIconESMobile}}/>
                                </p>
                                <h4 className="favorites__pane__title">
                                    <FormattedMessage id="noHistory"
                                        defaultMessage="No History Video Yet"
                                    />
                                </h4>
                            </div>
                        }
                    </Col>
                </Row>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        header: state.HeaderReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        setHeaderTitle,
        clearHistory,
        addChannelHistory,
        addVideoHistory,
        addShowHistory,
        getVideoOrChannelRelatedData,
        bucketAccess,
        searchText
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(History);


// WEBPACK FOOTER //
// ./src/components/History/History.js